module.exports = __webpack_public_path__ + "img/Kongespegelen_Kristen_litteratur.52099f25.jpg";